import { utilBuildings } from "../../../utils/utilBuildings";
import { selectAcresAvailable } from "../selectors/selectAcresAvailable";
export var checkAnyAcreProductionInProgressAvailable = function (path) { return function (action, state$, dependencies) {
    var acresAvailable = selectAcresAvailable(state$.value);
    var areAcresWithProductionInProgress = acresAvailable.some(utilBuildings.isProducing);
    return areAcresWithProductionInProgress ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyAcreProductionInProgressAvailable.ts
// module id = 2392
// module chunks = 3